function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _ from 'lodash';
import moment from 'moment';
import { getEnabledV2OrderTypes } from 'shared/core/helpers/dispensaries';
import { defaultDurationEstimates, defaultActionEstimates } from 'shared/constants';
var getDeliveryEstimate = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param, skipMatrixCheck) {
        var actionEstimates, deliveryActionEstimateOrDefault, baseTimeToPrepareOrder, defaultDeliveryBuffer, rangeInMinutes, roundTo, rounded, defaultDeliveryEstimate;
        return _ts_generator(this, function(_state) {
            actionEstimates = param.actionEstimates;
            deliveryActionEstimateOrDefault = _.get(actionEstimates, "delivery", defaultActionEstimates.delivery);
            baseTimeToPrepareOrder = _.get(deliveryActionEstimateOrDefault, "readyInMinutes", 25);
            // eslint-disable-next-line max-len
            defaultDeliveryBuffer = Math.ceil(_.get(deliveryActionEstimateOrDefault, "deliveryTimeInMinutes", 20) / 5) * 5; // round to nearest 5
            rangeInMinutes = _.get(deliveryActionEstimateOrDefault, "rangeInMinutes", 10);
            roundTo = baseTimeToPrepareOrder > 60 ? 10 : 5;
            rounded = Math.ceil(baseTimeToPrepareOrder / roundTo) * roundTo; // round to nearest 5 | 10 depending on size
            if (rounded === 0) {
                rounded = 25;
            }
            defaultDeliveryEstimate = {
                lowInMinutes: rounded + defaultDeliveryBuffer,
                highInMinutes: rounded + defaultDeliveryBuffer + rangeInMinutes
            };
            if (skipMatrixCheck) {
                return [
                    2,
                    {
                        lowInMinutes: rounded,
                        highInMinutes: rounded + rangeInMinutes
                    }
                ];
            }
            return [
                2,
                defaultDeliveryEstimate
            ];
        });
    });
    return function getDeliveryEstimate(_, skipMatrixCheck) {
        return _ref.apply(this, arguments);
    };
}();
var getPickupEstimate = function(param) {
    var actionEstimates = param.actionEstimates;
    var pickupActionEstimateOrDefault = _.get(actionEstimates, "pickup", defaultActionEstimates.pickup);
    var baseTimeToPrepareOrder = _.get(pickupActionEstimateOrDefault, "readyInMinutes", 20);
    var roundTo = baseTimeToPrepareOrder > 60 ? 10 : 5;
    var rounded = Math.ceil(baseTimeToPrepareOrder / roundTo) * roundTo;
    if (rounded === 0) {
        rounded = 20;
    }
    return {
        lowInMinutes: Math.max(rounded - 5, 5),
        highInMinutes: rounded + _.get(pickupActionEstimateOrDefault, "rangeInMinutes", 5)
    };
};
export var durationEstimatesForOrder = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(dispensary) {
        var skipMatrixCheck, deliveryOverride, pickupOverride, delivery, _tmp, pickup;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    skipMatrixCheck = (_arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}).skipMatrixCheck;
                    deliveryOverride = _.get(dispensary, "durationEstimateOverrides.delivery", false);
                    pickupOverride = _.get(dispensary, "durationEstimateOverrides.pickup", false);
                    if (!(deliveryOverride === null || deliveryOverride === void 0 ? void 0 : deliveryOverride.enabled)) return [
                        3,
                        1
                    ];
                    _tmp = deliveryOverride;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        getDeliveryEstimate(dispensary, skipMatrixCheck)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    delivery = _tmp;
                    pickup = (pickupOverride === null || pickupOverride === void 0 ? void 0 : pickupOverride.enabled) ? pickupOverride : getPickupEstimate(dispensary);
                    return [
                        2,
                        {
                            pickup: pickup,
                            delivery: delivery
                        }
                    ];
            }
        });
    });
    return function durationEstimatesForOrder(dispensary) {
        return _ref.apply(this, arguments);
    };
}();
export var formatEstimate = function(actionEstimate) {
    var serviceType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "pickup";
    var estimate = actionEstimate || defaultDurationEstimates[serviceType] || defaultDurationEstimates.pickup;
    var times = [
        estimate.lowInMinutes,
        estimate.highInMinutes
    ].filter(function(val) {
        return val;
    }).join(' - ');
    return times ? "".concat(times, " min") : null;
};
export var getAfterHoursWindow = function(openInfo) {
    var serviceType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "pickup";
    var _openInfo_serviceType;
    if (serviceType !== 'delivery' && serviceType !== 'inStorePickup' && serviceType !== 'curbsidePickup' && serviceType !== 'driveThruPickup') {
        serviceType = "pickup";
    }
    var _ref = (openInfo === null || openInfo === void 0 ? void 0 : (_openInfo_serviceType = openInfo[serviceType]) === null || _openInfo_serviceType === void 0 ? void 0 : _openInfo_serviceType.nextService) || {}, openMoment = _ref.openMoment, closeMoment = _ref.closeMoment;
    if (!openMoment || !closeMoment) {
        return {};
    }
    var now = moment();
    var tomorrow = now.clone().add(1, "day");
    var openDayDisplay;
    if (openMoment.isSame(now, "day")) {
        openDayDisplay = "today";
    } else if (openMoment.isSame(tomorrow, "day")) {
        openDayDisplay = "tomorrow";
    } else {
        openDayDisplay = openMoment.format("M/D");
    }
    var open = openMoment.format("h:mm a");
    var close = closeMoment.format("h:mm a");
    return {
        day: openDayDisplay,
        open: open,
        close: close
    };
};
export var getCombinedV2PickupHoursWindow = function(openInfo, dispensary) {
    var enabledV2OrderTypes = getEnabledV2OrderTypes(dispensary);
    var enabledPickupOrderTypes = _.filter(enabledV2OrderTypes, function(orderType) {
        return orderType !== "delivery";
    });
    // Get the next available opening time for the enabled pickup service types
    var availablePickupOpenTimes = _.compact(_.map(enabledPickupOrderTypes, function(orderType) {
        var _openInfo_orderType;
        return (_openInfo_orderType = openInfo[orderType]) === null || _openInfo_orderType === void 0 ? void 0 : _openInfo_orderType.nextService.openMoment;
    }));
    if (!availablePickupOpenTimes.length > 0) {
        return {};
    }
    var earliestAvailablePickupTime = moment.min(availablePickupOpenTimes);
    // Get the next latest closing time for the enabled pickup service types
    // that falls on the same day as the earliest available pickup time
    var availablePickupCloseTimes = _.filter(_.compact(_.map(enabledPickupOrderTypes, function(orderType) {
        var _openInfo_orderType;
        var closeMoment = (_openInfo_orderType = openInfo[orderType]) === null || _openInfo_orderType === void 0 ? void 0 : _openInfo_orderType.nextService.closeMoment;
        if (!closeMoment) {
            return null;
        }
        if (closeMoment.format("h:mm a") === '12:00 am') {
            // Since midnight closing times are stored as 12:00 am,
            // we need to subtract 1 minute for the correct closing time string.
            return closeMoment.clone().subtract(1, "m");
        }
        return closeMoment;
    })), function(closeMoment) {
        return closeMoment.isSame(earliestAvailablePickupTime, "day");
    });
    var latestAvailablePickupTime = moment.max(availablePickupCloseTimes);
    if (!earliestAvailablePickupTime || !latestAvailablePickupTime) {
        return {};
    }
    var now = moment();
    var tomorrow = now.clone().add(1, "day");
    var openDayDisplay;
    if (earliestAvailablePickupTime.isSame(now, "day")) {
        openDayDisplay = "today";
    } else if (earliestAvailablePickupTime.isSame(tomorrow, "day")) {
        openDayDisplay = "tomorrow";
    } else {
        openDayDisplay = earliestAvailablePickupTime.format("M/D");
    }
    var open = earliestAvailablePickupTime.format("h:mm a");
    var close = latestAvailablePickupTime.format("h:mm a");
    return {
        day: openDayDisplay,
        open: open,
        close: close
    };
};
export var formatAfterHoursEstimate = function(param) {
    var day = param.day, open = param.open, close = param.close;
    if (!day || !open || !close) {
        return "next service opportunity unknown";
    }
    return "".concat(day, ", ").concat(open, " - ").concat(close === "12:00 am" ? "11:59 pm" : close);
};
export var getServiceEstimateForCart = function(Cart) {
    var _Cart_order, _Cart_order1, _Cart_order2, _Cart_openInfoForDispensary_afterHoursServiceType_nextService, _Cart_openInfoForDispensary_afterHoursServiceType, _Cart_openInfoForDispensary;
    var serviceType = ((_Cart_order = Cart.order) === null || _Cart_order === void 0 ? void 0 : _Cart_order.deliveryOption) === 'delivery' ? 'delivery' : 'pickup';
    var afterHoursServiceType = ((_Cart_order1 = Cart.order) === null || _Cart_order1 === void 0 ? void 0 : _Cart_order1.deliveryOption) === 'pickup' ? 'inStorePickup' : (_Cart_order2 = Cart.order) === null || _Cart_order2 === void 0 ? void 0 : _Cart_order2.deliveryOption;
    var estimate = Cart.isAfterHoursOrder || !((_Cart_openInfoForDispensary = Cart.openInfoForDispensary) === null || _Cart_openInfoForDispensary === void 0 ? void 0 : (_Cart_openInfoForDispensary_afterHoursServiceType = _Cart_openInfoForDispensary[afterHoursServiceType]) === null || _Cart_openInfoForDispensary_afterHoursServiceType === void 0 ? void 0 : (_Cart_openInfoForDispensary_afterHoursServiceType_nextService = _Cart_openInfoForDispensary_afterHoursServiceType.nextService) === null || _Cart_openInfoForDispensary_afterHoursServiceType_nextService === void 0 ? void 0 : _Cart_openInfoForDispensary_afterHoursServiceType_nextService.openMoment) ? _.upperFirst(formatAfterHoursEstimate(getAfterHoursWindow(Cart.openInfoForDispensary, afterHoursServiceType))) : formatEstimate(Cart.durationEstimates[serviceType], serviceType);
    return estimate;
};
